import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import TranslateText from 'components/hoc/TranslateText';
import StatementWrapper from 'components/molecules/StatementWrapper';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import nuBankidApi from 'services/nezarazenyUcet/nuDedictvi';

interface IVypisUvod {}

const BankidLogin: React.FC<IVypisUvod> = () => {
    const history = useHistory();
    const { idzadosti } = useParams<{ idzadosti: string }>(); // idzadosti, sebrano z urlky pokud se v url vyskytuje pocitame s tim ze se uzivatel jiz prihlasil poprve a vraci se z odkazu na mailu.
    const [errStatus, setErrStatus] = useState<number>();

    const routeChange = () => {
        let path = idzadosti ? '/nezarazeny-ucet-zjisteni/bankid/' + idzadosti : '/nezarazeny-ucet-zjisteni/bankid';
        history.push(path);
    };

    const bankIdLogin = () => {
        nuBankidApi()
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((resp: any) => {
                window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID v new okne
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    const bankIdLoginZadost = () => {
        nuBankidApi(idzadosti)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((resp: any) => {
                window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky Bank ID v new okne
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
            });
    };

    return (
        <>
            {errStatus ? (
                <StatementWrapper pageTitle="">
                    <Col span={24}>
                        <Row>
                            {errStatus === 400 ? (
                                <Title text="RESPONSE_ERROR_400" level={3} />
                            ) : errStatus === 401 ? (
                                <Title text="RESPONSE_ERROR_401" level={3} />
                            ) : errStatus === 404 ? (
                                <Title text="RESPONSE_ERROR_404" level={3} />
                            ) : errStatus === 500 ? (
                                <Title text="RESPONSE_ERROR_500" level={3} />
                            ) : errStatus ? (
                                <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                            ) : null}
                        </Row>

                        <Row className="statement-buttons-row">
                            <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                        </Row>
                    </Col>
                </StatementWrapper>
            ) : (
                <>
                    {idzadosti ? (
                        <>
                            <h1>
                                <TranslateText>NU_POPIS_LOGIN_NADPIS</TranslateText>
                            </h1>
                            <StatementWrapper pageTitle="" pageInfoText="NU_POPIS_LOGIN_TEXT">
                                <Row className="statement-buttons-row">
                                    <ButtonComponent
                                        buttontext="PRIHLASIT_SE_PPRES_BANKID"
                                        onClick={bankIdLoginZadost}
                                    />
                                </Row>
                            </StatementWrapper>
                        </>
                    ) : (
                        <>
                            <h1>
                                <TranslateText>POPIS_SLUZBY</TranslateText>
                            </h1>
                            <div>
                                <TranslateText>NU_POPIS_STRANKY</TranslateText>
                            </div>
                            <StatementWrapper
                                pageTitle=""
                                pageInfoText=""
                                //  pageInfoTextBold="PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE2"
                                //  pageInfoTextBold2="PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE3"
                            >
                                <Row className="statement-buttons-row">
                                    <ButtonComponent buttontext="PRIHLASIT_SE_PPRES_BANKID" onClick={bankIdLogin} />
                                </Row>
                            </StatementWrapper>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default BankidLogin;
